import {damsFetch} from "../app/damsFetch";
import {pollShareStatus} from "./pollShareStatus";

/**
 * Shares documents or a folder with e-mail recipients (POST /share/), and returns how the e-mail went: 'sent',
 * 'waiting' while the previews convert (DE-1656), or 'pending' when the share was still being made after 2 minutes.
 *
 * DE-1723 (ADR-0011): the backend accepts the share at once (202 {sharing_uuid}) and makes it in the background, so
 * its outcome is asked for with short requests (pollShareStatus). A backend from before that answers
 * {status: 'completed', delivery} after making the share, which is returned as it is.
 *
 * @param {Object} payload - {object_uuids} or {folder_id}, recipient_emails and email_message.
 * @returns {Promise<string|undefined>} The delivery.
 * @throws When the backend refused the share, or reports that it failed.
 */
export const postShare = async (payload) => {
    const result = await damsFetch('/share/', {
        method: 'POST',
        headers: {'correlation-id': crypto.randomUUID(), 'Accept': 'application/json'},
        body: JSON.stringify(payload),
    });
    if (result?.sharingUuid) {
        return pollShareStatus(result.sharingUuid);
    }
    return result?.delivery;
};
